export enum LoaningState {
  DRAFT = 1,
  WAITING = 2,
  IN_PROGRESS = 3,
  DONE = 4,
}
